/**
 * overflowContainer
 * Enables a component to overflow a wrapping EoContainer sideways
 * to a given amount (none, md, lg, specific width) and at max the screen width
 * 
 * Set via prop (overflow-container) or via data (overflowSetting)
 * 
 * Use via (style="overflowStyles") on the element that should expand
 */
import scssVariables from '../components/EoContainer/EoContainer.scss?module'

export default {
  props: {
    /**
     * Overflow a wrapping EoContainer sideways (12, 10, 8, 6, 4, 2, none, fullwidth)
     */
    overflowContainer: {
      type: [String, Number],
      default: null,
    },
  },
  data () {
    return {
      // Overflow a wrapping EoContainer sideways (12, 10, 8, 6, 4, 2, none, fullwidth)
      overflowSetting: null,
      // Dynamically calculated offset to one side
      overflowOffset: 0,
    }
  },
  computed: {
    $_container () {
      // Find first EoContainer parent
      let containerComponent = null
      let parent = this.$parent
      while (parent && !containerComponent) {
        if (parent.$options.name === 'EoContainer') {
          containerComponent = parent
        }
        parent = parent.$parent
      }
      return containerComponent
    },
    overflowStyles () {
      // Inline styles provided for the wrapping element
      if (!this.overflowOffset) return {}
      if (this.overflowSettingResponsive === null) return {}
      if (this.overflowSettingResponsive === 'none') return {}
      return {
        marginLeft: `-${this.overflowOffset}px`,
        marginRight: `-${this.overflowOffset}px`,
        width: 'auto',
      }
    },
    overflowSettingResponsive () {
      return this.$viewport.switch(this.overflowSetting)
    },
  },
  watch: {
    /**
     * Watch changes from the prop
     */
    'overflowContainer': {
      handler: function (setting) {
        if (setting) {
          this.overflowSetting = setting
          this.$_calculateOffset()
        }
      },
      immediate: true,
    },
    /**
     * Watch width of container
     */
    '$_container.width': {
      handler: '$_calculateOffset',
      immediate: true,
    },
  },
  mounted () {
    this.$_calculateOffset()
  },
  methods: {
    async $_calculateOffset () {
      if (!this.overflowSetting) return
      if (!this.$_container) return

      // Find how much we maximally want to grow
      let widthToGrowTo = scssVariables[`container-width-${this.overflowSettingResponsive}`]?.replace('px', '')
      if (this.overflowSettingResponsive === 'fullwidth') widthToGrowTo = null

      // Set new offset
      if (widthToGrowTo === 0) {
        this.overflowOffset = 0
        return
      }
      if (widthToGrowTo === null) {
        this.overflowOffset = this.$_container.offset
        return
      }
      if (widthToGrowTo > this.$_container.containedWidth) {
        this.overflowOffset = (widthToGrowTo - this.$_container.containedWidth) / 2
      }
      if (widthToGrowTo > this.$_container.width) {
        this.overflowOffset = this.$_container.offset
      }
    },
  },
}
